import { useMessageThreadInfo } from "../../../hooks/useMessageThreadInfo";
import { Redo } from "lucide-react";
import "./HumanMessage.css";
import "../../common/MentionText.css";
import { HumanMessage as HumanMessageType } from "winslow-core";
import { useDispatch } from "react-redux";
import {
  setPrompt,
  openEmployeeProfileSidebar,
} from "../../../redux/features/agent/agentSlice";
import { ThreadInfo } from "../ThreadInfo";
import { MentionText } from "../../common/MentionText";
import { MessageThreadType } from "winslow-core";

type HumanMessageProps = {
  message: HumanMessageType;
  handleStartNewThread: (
    personaId: string | null,
    employeeId: string | null
  ) => void;
  currentThreadId: string | null;
};

export const HumanMessage = ({
  message,
  handleStartNewThread,
  currentThreadId,
}: HumanMessageProps) => {
  const contextInfo = useMessageThreadInfo(message.thread);

  const dispatch = useDispatch();

  const handleThreadInfoClick = (employeeId?: string) => {
    if (employeeId) {
      dispatch(openEmployeeProfileSidebar({ employeeId }));
    }
  };

  return (
    <div className=" agent-chat-human-message">
      <div className="agent-chat-history-item-prompt-container">
        <div className="agent-chat-history-item-prompt-hover-icon">
          <Redo
            size={16}
            onClick={() => {
              console.log(
                "message.message.kwargs.content",
                message.message.kwargs.content
              );
              dispatch(setPrompt(message.message.kwargs.content));
              const thread = message?.thread;
              if (currentThreadId !== thread?.id) {
                handleStartNewThread(
                  thread?.personaId || null,
                  thread?.employeeId || null
                );
              }
            }}
          />
        </div>
        <div
          id={"human_message_" + message.id.toString()}
          className="agent-chat-history-item-prompt">
          <div className="agent-chat-history-item-prompt-markdown markdown-body">
            <MentionText text={message.message.kwargs.content} />
          </div>
        </div>
      </div>
      {contextInfo && (
        <ThreadInfo
          showAvatar={true}
          avatar={contextInfo.avatar}
          label={contextInfo.label}
          onClick={handleThreadInfoClick}
          employeeId={contextInfo.employeeId}
          clickable={
            contextInfo.threadType === MessageThreadType.EMPLOYEE &&
            !!contextInfo.employeeId
          }
        />
      )}
    </div>
  );
};
